// extracted by mini-css-extract-plugin
module.exports = {"livePillarsSegmentHeading":"moreInformation-module--livePillarsSegmentHeading--2eqvx","livePillarsSegment":"moreInformation-module--livePillarsSegment--1o4ak"};